import axios from 'axios';

const ENDPOINT = process.env.REACT_APP_ENDPOINT;
const API_KEY = process.env.REACT_APP_AUTH_WEBSITE;

function getInstance() {

    let user_token = sessionStorage.getItem('@user_token');

    return axios.create({
        headers: {
            'X-AUTH-TOKEN': user_token ?? "",
            'X-ROLE': 'ROLE_WEBSITE',
            'X-API-KEY': API_KEY,
        }
    });
}

async function get(path) {
    return await getInstance().get(ENDPOINT + path);
}

async function getUrl(fullpath) {
    return await getInstance().get(fullpath);
}

async function post(path, params) {
    return await getInstance().post(ENDPOINT + path, params);
}

async function put(path, params) {
    return await getInstance().put(ENDPOINT + path, params);
}

async function DELETE(path) {
    return await getInstance().delete(ENDPOINT + path);
}

const API = {
    get,
    getUrl,
    post,
    put,
    DELETE,
}

export default API;